module.exports = __webpack_public_path__ + "static/img/9.e628ac4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/9.png
// module id = mHm2
// module chunks = 0